(function () {
  'use strict';
  if (window.__hmLoaded) return;
  window.__hmLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawerSections() {
    var d = document.querySelector('cart-drawer');
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }

  // Añade varias líneas en una sola petición y abre el carrito lateral compartido con la PDP.
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: drawerSections(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'No se pudo añadir al carrito.');
        var d = document.querySelector('cart-drawer');
        if (d && data.sections) {
          d.classList.remove('is-empty');
          d.renderContents(data);
        } else {
          window.location.href = root + 'cart';
        }
        return data;
      });
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function withDelims(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Tarjetas: botón de compra ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hm-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    addItems([{ id: parseInt(btn.getAttribute('data-hm-add'), 10), quantity: 1 }])
      .catch(function (err) { window.alert(err.message); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---------- Pack combinado ---------- */
  function initBundle(sec) {
    var fmt = sec.getAttribute('data-money-format');
    var items = Array.prototype.slice.call(sec.querySelectorAll('[data-hm-bundle-item]'));
    var totalEl = sec.querySelector('[data-hm-bundle-total]');
    var compareEl = sec.querySelector('[data-hm-bundle-total-compare]');
    var btn = sec.querySelector('[data-hm-bundle-add]');
    var msg = sec.querySelector('[data-hm-bundle-msg]');
    var busy = false;

    function state(item) {
      var hidden = item.querySelector('[data-hm-bundle-id]');
      var sel = item.querySelector('[data-hm-bundle-variant]');
      var src = sel ? sel.options[sel.selectedIndex] : hidden;
      return {
        on: item.querySelector('[data-hm-bundle-check]').checked,
        id: parseInt(sel ? sel.value : hidden.value, 10),
        price: parseInt(src.getAttribute('data-price'), 10) || 0,
        compare: parseInt(src.getAttribute('data-compare'), 10) || 0
      };
    }

    function update() {
      var total = 0, compare = 0, count = 0;
      items.forEach(function (item) {
        var s = state(item);
        item.querySelector('[data-hm-bundle-price]').textContent = formatMoney(s.price, fmt);
        var c = item.querySelector('[data-hm-bundle-compare]');
        c.textContent = formatMoney(s.compare, fmt);
        c.hidden = s.compare <= s.price;
        if (s.on) { total += s.price; compare += s.compare; count++; }
      });
      totalEl.textContent = formatMoney(total, fmt);
      compareEl.textContent = formatMoney(compare, fmt);
      compareEl.hidden = compare <= total;
      btn.disabled = count === 0 || busy;
      btn.setAttribute('aria-disabled', count === 0 ? 'true' : 'false');
    }

    sec.addEventListener('change', update);
    btn.addEventListener('click', function () {
      if (busy) return;
      var list = items.map(state).filter(function (s) { return s.on; }).map(function (s) { return { id: s.id, quantity: 1 }; });
      if (!list.length) return;
      busy = true; btn.disabled = true; msg.hidden = true;
      addItems(list)
        .catch(function (err) { msg.textContent = err.message; msg.hidden = false; })
        .finally(function () { busy = false; update(); });
    });
    update();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hm-bundle]'), initBundle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
